<template>
  <div class="design-share-manage">
    <div>

    </div>
    <div class="design-share-cards">
      <div v-for="(item, index) in shareThemes"
           :key="index"
           class="design-share-card">
        <div class="design-share-card-image">
          <img alt="example"
               :src="toUrl(item.shareImages[0].image)" />
        </div>
        <div class="design-share-content">
          <div class="design-share-title"><span>{{ item.title || $t('DesignShare.DesignShareManage.mysteriousTheme')
          }}</span></div>
          <!-- <div class="desgin-share-price">
            {{ '¥' + ' ' + new BigNumber(item.price).toFixed(2) }}
          </div> -->
          <div class="design-share-status-manage">
            <div class="design-share-status"
                 @click="updateStaus(item, item.status)"><a-button :disabled="item.status === 1">{{ item.status === 0 ?
                   $t('DesignShare.DesignShareManage.notListed') : item.status === 1 ?
                     $t('DesignShare.DesignShareManage.pendingReview')
                     : item.status === 2 ? $t('DesignShare.DesignShareManage.reviewed') : item.status === 3 ?
                       $t('DesignShare.DesignShareManage.reviewFailed') : $t('DesignShare.DesignShareManage.listed')
                 }}</a-button>
            </div>
            <a-tooltip v-if="item.status === 3 || (item.status === 0 && item.desc)">
              <template #title>{{ $t('DesignShare.DesignShareManage.checkReason') }}</template>
              <question-circle-outlined class="details-reason"
                                        @click="onDetailsReason(item.desc)" />
            </a-tooltip>
            <img src="../icon/edit.png"
                 @click='toShareTheme(item.id)'>
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model:visible="detailsReasonVisit"
             destroy-on-close
             :title="$t('DesignShare.DesignShareManage.reasonTitle')"
             @cancel="closeModel">
      <p>{{ detailsReasonDesc }}</p>
      <template #footer>
        <a-button key="submit"
                  type="primary"
                  @click="closeModel">{{ $t('DesignShare.DesignShareManage.gotIt') }}</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue"
import { fetchShareThemeList, updateShareThemeStatus } from "../api"
import type { ShareTheme } from "../configure"
import { useRouter } from "vue-router"
import { toUrl } from "@/utils"
import BigNumber from "bignumber.js"
BigNumber.config({ ROUNDING_MODE: 1 })
const shareThemes = ref<ShareTheme[]>([])
const router = useRouter()
const detailsReasonVisit = ref<boolean>(false)
const detailsReasonDesc = ref<string>('')

onMounted(() => {
  init()
})

const init = async () => {
  await fetchShareThemeList().then((res: any) => {
    shareThemes.value = res.theme
  })
}

const onDetailsReason = (value: string) => {
  detailsReasonVisit.value = true
  detailsReasonDesc.value = value
}

const closeModel = () => {
  detailsReasonDesc.value = ''
  detailsReasonVisit.value = false
}

const updateStaus = async (item: ShareTheme, status: number) => {
  // 0 未上架 1 待审核 2 已审核 3 审核未通过 4 上架  只有未上架 改为1  其他均改为0
  let changeStatus = 0
  switch (status) {
    case 0:
      changeStatus = 1
      break
    case 1:
      changeStatus = 0
      break
    case 2:
      changeStatus = 4
      break
    case 3:
      changeStatus = 1
      break
    case 4:
      changeStatus = 0
      break
  }
  await updateShareThemeStatus(item.id, { status: changeStatus }).then((res: any) => {
    item.status = res.status
  })
}

const toShareTheme = (themeId: number) => {
  router.push(`/console/products/design_share?themeId=${themeId}`)
}
</script>
<style scoped lang="less">
.design-share-manage {
  width: 100%;
  height: 100%;

  .design-share-cards {
    padding-top: 20px;
    padding-left: 20px;
    flex: 1;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    overflow-x: auto;
    gap: 12px;

    .design-share-card {
      margin-bottom: 10px;
      height: 410px;
      min-width: 300px;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.06);
      transition: box-shadow 0.3s ease, transform 0.3s ease;

      .design-share-card-image {
        width: 300px;
        min-height: 300px;
        max-height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #F6F6F6;

        img {
          max-width: 300px;
          width: auto;
          max-height: 300px;
          height: auto;
        }
      }

      .design-share-content {
        flex: 1;
        width: 300px;
        display: flex;
        justify-content: space-around;
        flex-flow: column;
        padding: 20px;

        .design-share-title {
          width: 90%;
          flex: 1;
          font-family: Microsoft YaHei;
          font-weight: bold;
          font-size: 16px;
          color: #111111;
          word-wrap: break-word;
          display: flex;
        }

        .desgin-share-price {
          flex: 1;
          font-family: Microsoft YaHei;
          font-weight: bold;
          font-size: 18px;
          color: #DE4A09;
        }

        .design-share-status-manage {
          cursor: pointer;
          width: 100%;
          height: 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .details-reason {
            font-size: 18px;
            color: rgba(255, 17, 0, 0.456);
          }

          .design-share-status {
            width: 80%;
            height: 80%;
            display: flex;
            justify-content: center;
            align-items: center;

            :deep(.ant-btn) {
              width: 100%;
              background: #F6F6F6;
              border-radius: 5px;
              border: 0;
            }
          }

          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }

    :hover.design-share-card {
      // box-shadow: 2px 10px 10px 0px rgba(0, 0, 0, 0.06);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
      transform: scale(1.05);
    }
  }
}
</style>
